import React from "react";
import { Card } from "react-bootstrap";
import { ContentResponse } from "../../services/api.response.service";
import { RouteEndpoints } from "../../services/route.service";
import { Mixpanel } from "../../services/mixpanel";
import { CheckContentProviderIdExist, getContentProviderId } from "../../services/app.service";
import TestsSection from "./TestsSection";
import NoData from "../../pages/main/NoData";

interface CourseContentTestProps {
  content: ContentResponse;
}

function CourseContentTest({ content }: CourseContentTestProps) {
  const handleSetTest = (id: string) => {
    Mixpanel.track("Tap Test", {
      with: "Auth",
      user_id: "",
      test_id: "",
      test_name: "",
      ...(CheckContentProviderIdExist()
        ? { content_provider_id: getContentProviderId() }
        : {}),
    });
    window.location.href = RouteEndpoints.CLASS_COURSES_TEST(id);
  };

  return (
    <Card className="h-100 w-100 overflow-scroll">
      <Card.Body className="p-3" style={{ height: "76em" }}>
        {content.tests.length > 0 ? (
          <TestsSection tests={content.tests} handleSetTest={handleSetTest} />
        ) : (
          <NoData title="noTest" />
        )}
      </Card.Body>
    </Card>
  );
}

export default CourseContentTest;
